import { githubFetch } from './client';

export interface GitHubFileGetParams {
  owner: string;
  repo: string;
  path: string;
  ref?: string;
  format?: 'json' | 'raw';
}

export interface GitHubFileGetResponse {
  content: string;
  sha: string;
  size: number;
  encoding: string;
  path: string;
}

export async function githubFileGet(
  params: GitHubFileGetParams
): Promise<GitHubFileGetResponse> {
  return githubFetch<GitHubFileGetResponse>('/rpc/github_file_get', {
    body: params,
  });
}
